import { format, parseISO } from 'date-fns';

// Helper to safely format dates using date-fns
export const formatDate = (dateString: string, formatStr: string = 'PPPp'): string => {
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : new Date(dateString);
    return format(date, formatStr);
  } catch (error) {
    console.warn('Date formatting error:', error);
    return new Date(dateString).toLocaleDateString();
  }
};

// Helper to format moment.js style formats to date-fns
export const formatMomentStyle = (dateString: string, momentFormat: string): string => {
  // Map common moment.js formats to date-fns formats
  const formatMap: Record<string, string> = {
    'LLL': 'PPPp',           // September 4, 1986 at 8:30 PM
    'DD.MM.YYYY - HH:mm': 'dd.MM.yyyy - HH:mm',
    'YYYY-MM-DD': 'yyyy-MM-dd',
    'DD/MM/YYYY': 'dd/MM/yyyy',
    'MM/DD/YYYY': 'MM/dd/yyyy',
  };

  const dateFnsFormat = formatMap[momentFormat] || momentFormat
    .replace(/YYYY/g, 'yyyy')
    .replace(/DD/g, 'dd')
    .replace(/MM/g, 'MM')
    .replace(/HH/g, 'HH')
    .replace(/mm/g, 'mm');

  return formatDate(dateString, dateFnsFormat);
};

// Long format for countdown display (equivalent to moment's LLL)
export const formatDateLong = (dateString: string): string => {
  return formatDate(dateString, 'PPPp');
};